"use strict";import{Menu as e}from"./src/Menu.js";import{defineElement as m}from"@spectrum-web-components/base/src/define-element.js";m("sp-menu",e);
//# sourceMappingURL=sp-menu.js.map
